import {
  LargeSquaredSwatch,
  SmallSquaredSwatch,
  SquaredSwatch,
} from '@joor/design-system'

export const MULTICOLOR_SWATCH_IMG_URL =
  'https://cdn.jooraccess.com/external/img/icons/swatch_multi_color_42x42.png'

export interface MulticolorSwatchProps {
  size?: 'small' | 'large' | 'default'
}
export const TestIds = {
  SmallSwatch: 'multicolor-swatch--small-swatch',
  LargeSwatch: 'multicolor-swatch--large-swatch',
  DefaultSwatch: 'multicolor-swatch--default-swatch',
} as const
export const MulticolorSwatch = ({
  size = 'default',
}: MulticolorSwatchProps) => {
  switch (size) {
    case 'small':
      return (
        <SmallSquaredSwatch
          testId={TestIds.SmallSwatch}
          disabled
          imageUrl={MULTICOLOR_SWATCH_IMG_URL}
        />
      )
    case 'large':
      return (
        <LargeSquaredSwatch
          testId={TestIds.LargeSwatch}
          disabled
          imageUrl={MULTICOLOR_SWATCH_IMG_URL}
        />
      )
    default:
      return (
        <SquaredSwatch
          testId={TestIds.DefaultSwatch}
          disabled
          imageUrl={MULTICOLOR_SWATCH_IMG_URL}
        />
      )
  }
}
